import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues, change } from 'redux-form';
import { withRouter } from 'react-router';
import v from 'validate.js';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { numberWithCommas, parseNumberWithCommas } from '../../../../../helpers';
import { trackingEvent } from '../../../../../helpers/tracking';
import { onSubmit } from '../../../../../common/components/submit-button';
import RenderInput from '../../../../../common/components/render-input';

export const formDetails = {
    key: 'transportation',
    title: 'Monthly Transportation',
    formName: Routes.STEPTHREE,
    totalKey: 'totalTransportation',
    range: {
        high: 20,
        low: 10
    },
    fields: {
        autoLoan: {
            label: 'Auto Loan(s)'
        },
        autoInsurance: {
            label: 'Auto Insurance'
        },
        autoMaintenance: {
            label: 'Auto Maintenance'
        },
        gasParking: {
            label: 'Gas / Parking'
        },
        publicTransportation: {
            label: 'Public Transportation'
        },
        other: {
            label: 'Other'
        }
    }
};

const tracking = {
    eventAction: 'Budget Calculator - Step 3',
    eventLabel: 'Transportation'
};

const minValue = 0;

const validate = values => v(values,
    Object.keys(formDetails.fields).reduce((obj, val) => ({
        ...obj,
        [val]: {
            numericality: {
                greaterThanOrEqualTo: minValue,
                notGreaterThanOrEqualTo: `must be greater than or equal to $${numberWithCommas(minValue)}`
            }
        }
    }), {})
);

class StepThreeForm extends Component {
    calculateTotal() {
        const {
            props: {
                formValues: {
                    [formDetails.totalKey]: removedTotal,
                    ...values
                }
            }
        } = this;

        return Object.values(values).reduce((total, val) => total + val, 0);
    }

    componentDidUpdate() {
        const {
            props: {
                changeFieldValue
            }
        } = this;

        changeFieldValue(formDetails.totalKey, this.calculateTotal());
    }

    render() {
        return (
            <form className={styles.form}>
                {
                    Object.keys(formDetails.fields).map(key => (
                        <Field
                            key={key}
                            type='text'
                            name={key}
                            label={formDetails.fields[key].label}
                            tooltip={formDetails.fields[key].tooltip}
                            prefix='$'
                            format={numberWithCommas}
                            parse={parseNumberWithCommas}
                            component={RenderInput}
                        />
                    ))
                }
            </form>
        );
    }
}

const formValues = getFormValues(formDetails.formName);

const mapStateToProps = (state) => ({
    formValues: formValues(state),
    paginationSkipState: state.calculator.paginationHasSkip,
});

const mapDispatchToProps = (dispatch) => ({
    changeFieldValue: (field, value) => dispatch(change(formDetails.formName, field, value))
});

StepThreeForm = reduxForm({
    form: formDetails.formName,
    destroyOnUnmount: false,
    validate,
    onSubmit,
    initialValues: Object.keys(formDetails.fields).reduce((obj, val) => ({
        ...obj,
        [val]: minValue
    }), {}),
    redirectPath: `/budget-planner${Routes.STEPFOUR}`,
    skipPath: `/budget-planner${Routes.SUMMARY}`,
    tracking: () => trackingEvent(tracking)
}, mapStateToProps, mapDispatchToProps)(StepThreeForm);

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(StepThreeForm));
